/*
 * DO NOT ADD more stuff below!
 * It will be loaded twice on every page that contains a ComeOn iframe!
 *
 * Note: please insert in alphabetical order, including path, for ease of verification!
 */
require([
	'all/lib/fakeLocalStorage',
	'realityCheck',
	'casino',
	'landing',
	'poker',
	'sportsbook',
	'all/bonusslider',
	'all/communicationbar',
	'all/counter',
	'all/dialog',
	'all/feature-toggles',
	'all/flushcommunicationbar',
	'all/footer',
    'all/hash-helper',
	'all/hash-monitor',
    'all/header',
	'all/interval-manager',
	'all/ie-unload-flash',
	'all/jquery/jquery.additional-methods',
	'all/jquery/jquery.ba-hashchange',
	'all/jquery/jquery.base64',
	'all/jquery/jquery.bpopup-0.8.0',
	'all/jquery/jquery.fileupload',
	'all/jquery/jquery.fittext',
	'all/jquery/jquery.form',
	'all/jquery/jquery.iframe-transport',
	'all/jquery/jquery.mustache',
	'all/jquery/jquery.parallax',
	'all/jquery/jquery.tooltip',
	'all/jquery/jquery.ui.widget',
	'all/jquery/jquery.validate',
	'all/jquery/jquery.xml2json',
	'all/lazyloader',
	'all/logoutConfirmation',
	'all/lib/stampit',
	'all/navigation',
	'all/Object',
	'all/paymentServices-toggles',
	'all/player/documents-uploader',
	'all/player/login',
	'all/player/login-dialog',
	'all/player/new-customer',
	'all/player/password',
	'all/player/player',
	'all/player/playerinfo',
	'all/player/registration',
	'all/player/security',
	'all/player/session',
	'all/player/uk-ageverify',
	'all/player/uk-terms',
	'all/player/uk-deposittandc',
	'all/player/uk-depositlimit-pendingcheck',
	'all/pretty-links',
	'all/scroller',
	'all/slider',
	'all/sliding-panel',
	'all/slidingContentNavigation',
	'all/slidingContentWrapper',
	'all/support',
	'all/template',
	'all/textKey',
	'all/special-urls-popup',
	'all/tracking-event',
	'boxes/box',
	'boxes/changePasswordBox',
	'boxes/deposit-box',
	'boxes/deposit-bonus/deposit-bonus-box',
	'boxes/deposit-bonus/deposit-bonus-model',
	'boxes/deposit-bonus/deposit-bonus-view',
	'boxes/deposit-result-box',
	'boxes/email-verification-box',
	'boxes/forgotten-password-box',
	'boxes/postal-mobile-verification-box',
	'boxes/login-box',
	'boxes/mobile-verification-box',
	'boxes/pending-withdraws-box',
	'boxes/signup-account',
	'boxes/signup-detail',
	'boxes/upload-documents-box',
	'boxes/withdraw-box',
	'boxes/withdraw-result-box',
	'boxes/controllers/box-controller',
	'boxes/controllers/deposit-controller',
	'boxes/controllers/login-controller',
	'boxes/controllers/signup-controller',
	'boxes/controllers/withdraw-controller',
	'boxes/events/bonus-event',
	'boxes/events/controller-event',
	'boxes/events/paymentEvent',
	'boxes/events/feeEvent',
	'boxes/events/landingEvent',
	'boxes/events/signUpEvent',
	'boxes/helpers/box-loading',
	'boxes/helpers/doLogin',
	'boxes/helpers/email-verification-handlers',
	'boxes/helpers/formValidation',
	'boxes/helpers/loginHelper',
	'boxes/helpers/message-popup',
    'boxes/helpers/middle-bar-helper',
	'boxes/helpers/payment-helpers',
	'boxes/helpers/payment-renderer-helper',
	'boxes/helpers/payment-sender-helper',
	'boxes/helpers/signUpValidation',
	'boxes/helpers/tooltip',
	'boxes/helpers/uk-deposit-limit',
	'boxes/helpers/verification',
	'boxes/helpers/address-finder',
	'casino/activity-feed',
	'casino/allgames',
	'casino/bundles',
	'casino/casino',
	'casino/casino-data',
	'casino/detect-zoom',
	'casino/game',
	'casino/game-mode',
	'casino/game-resize',
	'casino/info',
	'casino/ingame',
	'casino/ingameFunctionalities',
	'casino/instantdeposit',
	'casino/jackpots',
	'casino/lobby',
	'casino/love',
	'casino/mycasino',
	'casino/navigation',
	'casino/populate',
	'casino/providers/CTXM',
	'casino/providers/Evolution',
	'casino/providers/Microgaming',
	'casino/providers/netent/gameinclusion',
	'casino/providers/netent/NetEntLiveCasino',
	'casino/providers/nolimit/NoLimitCity',
	'casino/providers/nolimit/nolimit',
	'casino/providers/PlayNGo',
	'casino/providers/Yggdrasil',
	'casino/quick-change',
	'casino/search',
	'casino/start',
	'casino/tournaments',
	'casino/winners',
	'mypages/accountlimitations/depositLimitation',
	'mypages/accountlimitations/depositLimitPopup',
	'payment/handlers/sendHandlers/asynchronousResultAfterSingleCallHandler',
	'payment/handlers/sendHandlers/sendHandlerController',
	'payment/handlers/sendHandlers/externalPanelHandler',
	'payment/handlers/sendHandlers/externalWindowHandler',
	'payment/handlers/sendHandlers/internalPanelHandler',
	'payment/handlers/sendHandlers/pendingAfterSingleCallHandler',
	'payment/handlers/sendHandlers/resultAfterSingleCallHandler',
	'payment/handlers/sendHandlers/externalWindowIframeHandler',
	'payment/handlers/formTemplateHandlers/bankWireTemplateHandler',
	'payment/handlers/formTemplateHandlers/formTemplateHandlers',
	'payment/handlers/paymentMethodHandlers/creditCardMethodHandler',
	'payment/handlers/paymentMethodHandlers/paymentMethodHandlers',
	'payment/handlers/paymentMethodHandlers/siruMethodHandler',
	'payment/handlers/paymentMethodHandlers/trustlyWithdrawMethodHandler',
	'payment/handlers/kyc-validator',
	'payment/methods/providerAmountWithdraw',
	'payment/templates/deposit-renderer',
	'payment/templates/deposit-sender',
	'payment/templates/form-template',
	'payment/templates/payment-controller',
	'payment/templates/withdraw-renderer',
	'payment/templates/withdraw-sender',
	'payment/depositAmounts',
	'payment/externalPanel',
	'payment/externalPopupWindow',
	'payment/depositFee',
	'payment/getPaymentResult',
	'payment/paymentOperationMetadata',
	'all/jquery/jquery.ellipsis',
	'deviceId/deviceId'

	//this is required for our svg fetching method on i.e9 & >, this may not be the best place, but entry point is difficult to find.
	//feel free to move it, but test svg flags in footer on i.e9 afterwards
], function (realityCheck) {
	/* Do note: The above call to require, and as a consequence, this actual function is executed
	 * once for the main page, and once for any comeon iframe of the main page.

	 * The realityCheck defined by the main page call to require needs to be callable
	 * from the iframe for page /gb/my-pages/#!account-limits.
	 */
	if (window === top) {
		window.comeonExports = window.comeonExports || {};
		window.comeonExports.realityCheck = window.comeonExports.realityCheck || realityCheck;
	}
});

require.config({
    shim: {
		// Netent game inclusion API
		'casino/providers/netent/gameinclusion': {
			exports: 'netent'
		}
        // load jQuery plugins not compatible with AMD:
		// please rewrite jquery plugins to AMD modules
    }
});


define("all", function(){});

